document.querySelectorAll('.sst-hero--slider').forEach((hero) => {
  const wrap = hero.closest('.sst-hero-wrap') || hero.parentElement;
  const slides = Array.from(hero.querySelectorAll('.sst-hero__panel'));
  const dots = wrap ? Array.from(wrap.querySelectorAll('.sst-hero__dot')) : [];
  if (slides.length < 2 || dots.length !== slides.length) return;

  let frame = null;

  function setActive(index) {
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function updateActive() {
    frame = null;
    const heroCenter = hero.getBoundingClientRect().left + hero.clientWidth / 2;
    let activeIndex = 0;
    let closestDistance = Infinity;
    slides.forEach((slide, index) => {
      const rect = slide.getBoundingClientRect();
      const distance = Math.abs(rect.left + rect.width / 2 - heroCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });
    setActive(activeIndex);
  }

  function requestUpdate() {
    if (!frame) frame = requestAnimationFrame(updateActive);
  }

  function scrollToIndex(index) {
    const boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
    setActive(boundedIndex);
    hero.scrollTo({ left: boundedIndex * hero.clientWidth, behavior: 'smooth' });
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToIndex(index);
    });
    dot.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const nextIndex =
        event.key === 'ArrowRight' ? Math.min(index + 1, dots.length - 1) : Math.max(index - 1, 0);
      dots[nextIndex].focus();
      dots[nextIndex].click();
    });
  });

  hero.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  updateActive();
});
